import {HomeCard} from './HomeCard';
import Learner from '../../../assets/images/learner.jpg';
import {LearnerPortalPrimaryColor} from '../../../theme/ThemeLearnerPortalPalette';
import {routes} from '../../common/constants/routes';

export default function HomeLearnerPortalCard(): JSX.Element {
  return (
    <HomeCard
      cover={Learner}
      smallCoverUrl={Learner}
      title="Learner Portal"
      background={LearnerPortalPrimaryColor.main}
      path={routes.learnerPortal.overview}
    />
  );
}
